<template lang="pug">
	.login
		.login-logo
		.google-login(v-on:click="openGoogleLogin()")
</template>

<script>
	import Screen 							from './../../mixins/screen';
	import SetupSettings 					from "./../../settings/settings.json";
	import { User } 						from './../../services/User'

	export default {
		name: 'Auth',
		mixins: [Screen],
		screen: {
			updateOn: ["Current User Changed"]
		},
		data() {

			this.User = User;

			let params = location.search.substr(1).split('&');
			params = _.mapKeys(params, v => v.split('=')[0]);
			params = _.mapValues(params, v => v.split('=')[1]);

			return {

			}

		},
		created() {

			const image1 = new Image();
			image1.src = '/img/login/google/web/2x/btn_google_signin_dark_focus_web@2x.png';

			const image2 = new Image();
			image2.src = '/img/login/google/web/2x/btn_google_signin_dark_pressed_web@2x.png';

		},
		methods: {
			collectData() {

			},
			openGoogleLogin() {

				document.location = SetupSettings.loginUrlGoogle;

			},
			popupCenter(url, title, w, h) {

				// Fixes dual-screen position                         Most browsers      Firefox
				let dualScreenLeft = window.screenLeft !== undefined ? window.screenLeft : window.screenX;
				let dualScreenTop = window.screenTop !== undefined ? window.screenTop : window.screenY;

				let width = window.innerWidth ? window.innerWidth : document.documentElement.clientWidth ? document.documentElement.clientWidth : screen.width;
				let height = window.innerHeight ? window.innerHeight : document.documentElement.clientHeight ? document.documentElement.clientHeight : screen.height;

				let systemZoom = width / window.screen.availWidth;

				let left = (width - w) / 2 / systemZoom + dualScreenLeft;
				let top = (height - h) / 2 / systemZoom + dualScreenTop;

				let newWindow = window.open(url, title, 'scrollbars=yes, width=' + w / systemZoom + ', height=' + h / systemZoom + ', top=' + top + ', left=' + left);

				// Puts focus on the newWindow
				if (window.focus) newWindow.focus();

			}
		}
	}
</script>

<style lang="sass" scoped>

	.login
		display: flex
		justify-content: center
		align-items: center
		background: center top / 100% auto no-repeat fixed
		background-size: cover
		flex-direction: column
		width: 100vw
		height: 100vh

		.login-logo
			position: absolute
			left: 5px
			top: 5px
			background: url("../../../public/img/logo/prvk-white.png") center no-repeat
			background-size: contain
			width: 160px
			height: 66px

		.google-login
			display: flex
			width: 200px
			height: 50px
			background: url("/img/login/google/web/2x/btn_google_signin_dark_normal_web@2x.png") center no-repeat
			background-size: contain
			cursor: pointer
			filter: drop-shadow(0px 0px 5px rgba(0, 0, 0, 0.4))

			&:hover
				background: url("/img/login/google/web/2x/btn_google_signin_dark_focus_web@2x.png") center no-repeat
				background-size: contain

			&:active
				background: url("/img/login/google/web/2x/btn_google_signin_dark_pressed_web@2x.png") center no-repeat
				background-size: contain

</style>
